/** Uses `accounting.{name}` when a translation exists; otherwise returns the raw name. */
export function getPaymentTermDisplayName(
  name: string | null | undefined,
  translate: (key: string, options?: { defaultValue?: string }) => string,
): string {
  if (!name) {
    return "";
  }
  return translate(`accounting.${name}`, { defaultValue: name });
}
